module.exports = __webpack_public_path__ + "static/img/年度最佳热水器.5973e4c1.png";